import Config from "Config";
import { getApiClient } from "@ROM/App/ApiClient";

const API_URL = Config.API_FULL_URL;

const urls = {
  collection() {
    return "/permissions";
  },
};

export default {
  fetchPermissions() {
    const client = getApiClient(API_URL);
    return client.get(urls.collection());
  },
};
